<div class="popover-container" id="popover-overlay">
  <ng-content></ng-content>
</div>
